export default "__VITE_ASSET__ft636Zda__"